import React, { useState, useContext, useEffect } from 'react'
import { useHistory, useParams } from 'react-router'
import './exploreuser.sass'
import { useSelector, useDispatch } from 'react-redux'
import { starUser, unStarUser, isStarred } from "../../api/social"
import { DarkModeContext } from '../../global/Theme'
import { getUserByUsername } from '../../api/auth'
import { EmptyScreen } from '../../components/common/EmptyScreen'
import { ExploreSuggested, FeedCardLazy, Suggested } from '../../components/feed'
import { getTrendingPosts } from '../../api/explore'


export default function ExploreTrending() {

    const { username } = useParams();
    // const history = useHistory();
    const dispatch = useDispatch()
    const { isDark } = useContext(DarkModeContext);
    const [id, setId] = useState("");
    const [trendingPosts, setTrendingPosts] = useState([]);
    const [userDataStore, setUserDataStore] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false);
    const [postsLoaded, setPostsLoaded] = useState(false);
    const [starred, setStarred] = useState(0);
    const history = useHistory();
    const [isMobile, setIsMobile] = useState(true);
    const [width, setWidth] = useState(document.body.clientWidth);

    const updateWindowWidth = () => {
        setWidth(document.body.clientWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        updateView(width);
        if (width < 850) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [width])

    const getIsStarred = async () => {
        const res = await isStarred(userDataStore);
        if (res) setStarred(1)
        else setStarred(2);
    }

    const updateView = (v) => {
       // document.getElementById('custom-header').style.display = 'flex'
        if (v <= 580) {
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            document.getElementById('mainWrapper').style.cssText = 'padding: 70px 10px !important'

            // document.getElementById('mobileNav').style.display = "none"
            // document.getElementById('custom-header').style.margin = '-70px -10px 0px -10px'
        }
        else {
            if (v < 850 && document.getElementById('custom-header')) {
                document.getElementById('custom-header').style.margin = '0'
            }
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            document.getElementById('mobileNav').style.display = "flex"
        }
        if(v > 850 && document.getElementById('custom-header')) {
            document.getElementById('custom-header').style.display = 'flex'
        }
    }

    useEffect(() => {
        getUserData();
    }, [])


    useEffect(() => {
        if (userDataStore !== null) {
            setId(userDataStore.id)
            getIsStarred();
        }
    }, [userDataStore])




    const getUserData = async () => {
        const res = await getUserByUsername(username)
        setUserDataStore(res);
        setIsLoaded(true);
    }



    let trendTemp = []
    const loadTrendingPosts = async () => {
        getTrendingPosts(async observer => {
            trendTemp = []
            console.log("CHANGE TREDING!!")
            for (var i = 0; i < observer.docs.length; i++) {
                trendTemp.push({
                    post: observer.docs[i].data(),
                });
            }
            setTrendingPosts(trendTemp)
        })
    }

    useEffect(() => {
        loadTrendingPosts();
    }, [id])

    useEffect(() => {
        if (trendingPosts && trendingPosts.length > 0) {
            setPostsLoaded(true)
            if (document.getElementById('feedSuggested')) {
                document.getElementById('feedSuggested').style.paddingTop = '0'
            }
        }

    }, [trendingPosts])

    useEffect(() => {
        if (trendingPosts) {
            if (trendingPosts.length > 0) {
                const postid = history.location.state
                if (postid && postid.postId) {
                    if (document.getElementById(`${postid.postId}`)) {
                        const post = document.getElementById(`${postid.postId}`).getBoundingClientRect();
                        const top = post.top - 90;
                        if (isMobile) {
                            window.scrollTo({
                                left: 0,
                                top: top,
                                // behavior: "smooth",
                            })
                        } else {
                            window.scrollTo({
                                left: 100,
                                top: top,
                                //behavior: "smooth",
                            })
                        }

                    }
                }
            }
        }
    }, [trendingPosts])

    return (
        <div style={{ width: '100%' }} id='mobile-view-exploreuser'>
            {
                !isMobile ?
                    "" :
                    <div className={`${isDark ? 'profile-name-card-dark' : 'profile-name-card-light'}`} id='custom-header' style={{ marginTop: '1px', zIndex: '100', marginBottom: '10px' }}>
                        <img style={{ zIndex: '2' }} onClick={() => { history.goBack() }} src={require('../../assets/icons/backbutton.svg')} />
                        <p>{(userDataStore != null) ? `Trending Posts` : ''}</p>
                    </div>
            }
            {
                isLoaded && userDataStore != null && <div className='explore-user-wrapper' id='explore-user-wrapper'>
                    <div className='explore-col-L' id='explore-col-L'>
                        <div className='explore-col-L-wrapper'>
                            <ExploreSuggested />
                        </div>
                    </div>
                    <div className='explore-col-R' id='explore-col-R' >
                    

                        {
                            (trendingPosts && trendingPosts.length === 0) ?
                                <EmptyScreen logo="home_a" description="Follow or subscribe Lovrs to start seeing the photos and videos they share" heading="Welcome to LOVR Online" btntext="Explore LOVR" /> :
                                trendingPosts.map((v) => {
                                    {/* console.log(v) */ }
                                    return <FeedCardLazy
                                        userID={v.post.user}
                                        key={v.post.id}
                                        likeMap={v.post.whoLiked}
                                        bookmarkMap={v.post.whoBookmarked}
                                        commentMap={v.post.whoCommented}
                                        postId={v.post.id}
                                        location={v.post.location}
                                        image={v.post.media}
                                        placeholder={v.post.placeholder}
                                        body={v.post.body}
                                        likesCount={v.post.likesCount}
                                        commentsCount={v.post.commentsCount}
                                        time={v.post.time}
                                        type={v.post.type} />
                                })
                        }
                    </div>
                </div>
            }
        </div>
    )

}

// userThumb={v.user.thumbnail}
